import Tooltip from 'components/tooltip/Tooltip';
import BoxArrowUpRightIcon from 'assets/images/icons/box-arrow-up-right.svg?react';
import { Trans, useTranslation } from 'react-i18next';
import { IconLinkStyled } from 'pages/integrations/integrationDetails/components/propertiesList/propertiesResults/propertyListItem/PropertyListItem.styles';

const ViewListingLink = ({ publicLink }: { publicLink: string | null }) => {
  const { t } = useTranslation();

  if (!publicLink) return null;

  return (
    <Tooltip
      id="view-listing-icon"
      text={<Trans i18nKey="pageProperty.channels.viewListing" />}
    >
      <IconLinkStyled
        to={publicLink}
        aria-label={t('pageProperty.channels.viewListing')}
        data-testid="view-listing-icon"
        target="_blank"
        rel="noreferrer"
      >
        <BoxArrowUpRightIcon />
      </IconLinkStyled>
    </Tooltip>
  );
};

export default ViewListingLink;
